"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="20419" id="project-overview" className="relative h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/hero_coastal_stone.png" alt="Soft coastal light on stone texture" className="h-full w-full object-cover object-center" />
        {}
        <div className="absolute inset-0 bg-primary/40 mix-blend-multiply" />
      </div>

      {}
      <div className="relative z-10 flex h-full w-full items-center justify-center px-6">
        <div ref={ref} className={cn("mx-auto max-w-4xl text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-[20px] opacity-0")}>
          <h1 className="font-default text-5xl font-extrabold leading-tight tracking-normal text-primary-foreground md:text-7xl lg:text-[4.5rem]">MỘT SỐ CÔNG TRÌNH TIÊU BIỂU ĐÃ TRIỂN KHAI</h1>
          
          <p className="mx-auto mt-6 max-w-2xl font-mono text-lg leading-relaxed text-primary-foreground/90 md:text-xl lg:text-xl"><br /></p>

          <div className="mt-10 flex justify-center">
            <Button asChild className="h-auto rounded-none border-l-4 border-ring bg-primary px-8 py-4 text-lg text-primary-foreground shadow-none transition-transform duration-300 hover:scale-[1.02] hover:bg-primary/95">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}